module.exports = {
  NON_PO_ITEMS: [
    'Page',
    'GL Category',
    'GL Account',
    'Description 1',
    'Gross Price',
  ],
  NON_PO_ITEMS_ADVANCES: [
    'Page',
    'GL Category',
    'GL Account',
    'ProjectClass',
    'Description 1',
    'Gross Price',
  ],
  PO_ITEMS: [
    'Page',
    'GL Category',
    'GL Account',
    'Item Numbers',
    'Description 1',
    'Gross Price',
  ],
  PO_ITEMS_ADVANCES: [
    'Page',
    'GL Category',
    'GL Account',
    'Item Numbers',
    'ProjectClass',
    'Description 1',
    'Gross Price',
  ],
}
